module.exports = new __parcel__URL__("machines_bp_water_cooler_cosmetic_level_1.07115a4d.png").toString();